"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const SvgIcon_1 = tslib_1.__importDefault(require("@mui/material/SvgIcon"));
/**
 * Icon to indicate that a filter is active in dashboard
 */
const Filter = (
// Allows the callee to override the default values and pass any additional prop of SvgIcon. See https://material-ui.com/api/svg-icon/
{ fontSize = "small", ...rest }, forwardedRef) => (react_1.default.createElement(SvgIcon_1.default, { ...{ fontSize, ...rest, ref: forwardedRef } },
    react_1.default.createElement("line", { x1: "0", y1: "0", x2: "200", y2: "200" }),
    react_1.default.createElement("path", { d: "M0,0h24 M24,24H0", fill: "none" }),
    react_1.default.createElement("path", { d: "M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z" }),
    react_1.default.createElement("path", { d: "M0,0h24v24H0V0z", fill: "none" })));
const IconWithRef = react_1.default.forwardRef(Filter);
if (process.env.NODE_ENV !== "production") {
    // @ts-ignore: Expose property used for testing
    IconWithRef.Naked = Filter;
}
exports.default = IconWithRef;
